import axios from 'axios'

export default {
    getDashboard(){
        return axios.get('/dashboard')
            .then(response => {
                return response.data
            })
    },
  
    
}